<template>
	<div>
		<pt-form-item label="是否合格:" labelWidth="120px" :required="true">
			<el-radio-group v-model="form.result" name="result" v-validate="'required'" data-vv-as="是否合格">
				<el-radio label="QUALIFIED">合格</el-radio>
				<el-radio label="NOT_QUALIFIED_WAIT_FUTURE_ACTION">不合格</el-radio>
			</el-radio-group>
		</pt-form-item>
		<pt-form-item label="HG发出快递单号:" labelWidth="120px"  :required="true" v-if="form.result == 'QUALIFIED'">
			<el-input v-model="form.expressNum" placeholder="请填写快递单号" v-validate="'required'" data-vv-as="HG发出快递单号"></el-input>
		</pt-form-item>
		<pt-form-item label="原因:" labelWidth="120px" v-else>
			<el-input type="textarea" :autosize="{ minRows: 5, maxRows: 6 }" v-model="form.reason" class="texta" placeholder="请填写原因"></el-input>
		</pt-form-item>
	</div>
</template>

<script>
import { validate } from 'utils/validate'
import { next } from '../status.js'
export default {
  props: {
    order: {
      type: Object,
      required: true
    },
    status: {
      type: String,
      required: true
    },
    detailIn: {
      type: Boolean,
      default: false
    },
    orderStatus: [Array]
  },
  data () {
    return {
      title: '样本回寄',
      form: {
        result: 'QUALIFIED',
        reason: '',
        expressNum: ''
      }
    }
  },
  methods: {
    formValidata () {
      return validate(this, this.form)
    },
    next () {
      let data = { orderIds: [this.order.id],
        action: this.status }
      if (this.form.result === 'NOT_QUALIFIED_WAIT_FUTURE_ACTION') {
        data.orderStatusDetail = {
          orderStatusResult: this.form.result,
          reason: this.form.reason
        }
      } else {
        data.orderStatusDetail = {
          orderStatusResult: this.form.result,
          expressId: this.form.expressNum
        }
      }
      return next.call(this, data)
    }
  },
  created () {

  }

}
</script>

<style lang="less">

</style>
